import { Input, Component } from '@angular/core';
import { Review } from '../../../../../../shared/review';

@Component({
  selector: 'app-slide-entry',
  templateUrl: './slide-entry.component.html',
  styleUrls: ['./slide-entry.component.scss']
})
export class SlideEntryComponent {

  @Input() mobile:false;
  @Input() reviews: Review[];

  formText(review:string){
   return "\u{201C}" + (review.trim().length > 100 ? review.trim().substring(0, 100) + '...' : review.trim()) + " \u{201D}";
  }

  truncateName(review:any){
    //most of cases
    let name = review.first_name + "\u{00A0}from\u{00A0}" + review.full_state_name;
    //some of cases
    if(name.length > 27 ){
      name = review.first_name + "\u{00A0}from\u{00A0}" + review.state;
    }
    //rare case
    if(name.length > 27 ){
      name = review.first_name + ",\u{00A0}" + review.state;
    }
    //very rare case
    if(name.length > 27 ){
      name = review.first_name.substring(0,27);
    } 
    return name;
  }
}
